'use client';

import './Toolbar.scss';
import { barButtons } from '../../../../../contstants/product';
import Button from '../../../ui/Button/Button';
import { scrollTo } from '../../../../../utils/scrollTo';
import { ButtonStyleType } from '../../../../../enums/button';
import { Link } from '@sitecore-jss/sitecore-jss-react';
// import Link from 'next/link';

export const barMenu = [
  {
    id: 1,
    title: 'Overview',
  },
  {
    id: 2,
    title: 'Design',
  },
  {
    id: 3,
    title: 'Specs',
  },
];

export default function SpecificationsToolbar({ field }) {
  const handleScrollTo = (value) => {
    scrollTo(value);
  };
  return (
    <div className={'toolbar'} data-aos="fade-up" data-aos-offset="100">
      <div className={'left'}>
        <span className={'left_headline'}>{field?.headingTitle?.value}</span>
        <ul className={'left_list'}>
          {field?.anchores.map((item) => (
            <li
              className={'left_item'}
              key={item.id}
              onClick={() => handleScrollTo(item?.fields?.result?.value)}
            >
              {item?.fields?.column?.value}
            </li>
          ))}
        </ul>
      </div>
      <div className={'right'}>
        {field?.buttons.map((item, index) => (
          <div key={item.id} className={'right_buttonContainer'}>
            {item?.fields?.buttonUrl ? (
              <Button
                className={'right_button'}
                variant={index === 2 ? ButtonStyleType.Primary : ButtonStyleType.Secondary}
                isShowTooltip={false}
                target={`${item?.fields?.buttonUrl?.value?.href || ''}${
                  item?.fields?.buttonUrl?.value?.querystring || ''
                }`}
              >
                {item?.fields?.buttonText?.value}
              </Button>
            ) : (
              <Button
                className={'right_button'}
                variant={index === 2 ? ButtonStyleType.Primary : ButtonStyleType.Secondary}
              >
                {item?.fields?.buttonText?.value}
              </Button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
